import React from "react";
import { Button } from "../../../components/button.jsx";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../../components/fields/simpleField.jsx";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as PropTypes from "prop-types";
import { BulkActions } from "./contactPage/table/bulkActions.jsx";
import { Cell } from "./contactPage/table/cell.jsx";
import { PaginationTable } from "../../../components/table/paginationTable.jsx";
import { SubmitButton } from "../../../components/fields/submitButton.jsx";
import { usePagination } from "../../../hooks/usePagination.js";
import { contactLabel } from "../../../services/labels";

export function ContactPage() {
  let [search, setSearch] = useSearchParams();
  let navigate = useNavigate();

  let pagination = usePagination({
    key: "contact",
    meta: {
      sort: "-when",
      search: search.get("search") || "",
      filters: search.get("filters") || "",
    },
  });

  let { control, handleSubmit, watch, setValue, formState, reset } = useForm({
    resolver: zodResolver(
      zod.object({
        search: zod.string(),
        filters: zod.string(),
      })
    ),
    defaultValues: {
      search: search.get("search") || "",
      filters: search.get("filters") || "",
    },
  });

  return (
    <div className={"w-full flex flex-col h-full gap-3 p-3"}>
      <div className={"flex items-center gap-3"}>
        <form
          onSubmit={handleSubmit((d) => {
            setSearch(d);
            pagination.setMeta(d);
            reset({}, { keepValues: true });
          })}
          className={"flex flex-col gap-3 w-full"}
        >
          <div className={"flex gap-3 items-center w-full"}>
            <h2 className={"font-bold hidden md:block"}>Contacts</h2>
            <SimpleField
              name={"search"}
              control={control}
              placeholder={"Search contacts"}
            />
            <SubmitButton formState={formState}>
              <span className={"fa fa-search"} />
            </SubmitButton>

            <Button onClick={() => navigate("/contacts/new")}>
              <span className={"fa fa-plus"} />{" "}
            </Button>

            <div className={"flex-grow"}></div>
          </div>
        </form>
      </div>

      <PaginationTable
        resourceName={"contacts"}
        pagination={pagination}
        onRowClick={(record) => navigate("/contacts/" + record.id)}
        component={({ line }) => (
          <div className={"pb-1"}>
            <div
              className={
                "p-3 bg-white rounded cursor-pointer hover:bg-blue-100"
              }
            >
              {contactLabel(line)}
            </div>
          </div>
        )}
        noDataState={
          <p>
            <div
              className={"flex gap-5 items-center p-10 flex-col md:flex-row"}
            >
              <div
                className={
                  "bg-white flex items-center justify-center text-5xl "
                }
                style={{ borderRadius: "100%", minWidth: 200, minHeight: 200 }}
              >
                <span className={"fa fa-address-book text-blue-100"} />
              </div>
              <div>
                <strong>You don't have any contact yet.</strong>
                <br />
                <br />
                Contacts are your customers and providers.
                <br />
                <br />
                To add a contact, please import data using the{" "}
                <span className={"fa fa-plus"} /> button.
              </div>
            </div>
          </p>
        }
        noResultState={
          <p>
            <div
              className={"flex gap-5 items-center p-10 flex-col md:flex-row"}
            >
              <div
                className={
                  "bg-white flex items-center justify-center text-5xl "
                }
                style={{ borderRadius: "100%", minWidth: 200, minHeight: 200 }}
              >
                <span className={"fa fa-search text-blue-100"} />
              </div>
              <div>
                <strong>No result found</strong>
                <br />
                <br />
                We didn't find any contact matching your search. Please try
                searching with more broader terms.
              </div>
            </div>
          </p>
        }
      />
    </div>
  );
}
